import request from '@/utils/request'

/**
 * 字典数据管理API
 *
 * @author Jay Qing
 * @since 2020/11/25
 */

/**
 * 基础接口
 *
 * @type {string}
 */
export const BASE_URL = '/system/dictionary-data'

/**
 * 分页查询接口
 *
 * @type {string}
 */
export const PAGE_URL = `${BASE_URL}/page`


/**
 * 查询指定ID的数据
 *
 * @param id ID
 * @returns {Promise}
 */
export function get(id: any) {
  return request({
    url: `${BASE_URL}/get/${id}`,
    method: 'get'
  })
}

/**
 * 查询指定字典代码的字典数据
 *
 * @param dictCode 字典代码
 * @return {Promise}
 */
export function listByDictCode(dictCode: any) {
  return request({
    url: `${BASE_URL}/list`,
    method: 'get',
    params: {
      dictionaryCode: dictCode
    }
  })
}

/**
 * 保存数据
 *
 * @param data 数据
 * @returns {Promise}
 */
export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

/**
 * 更新数据
 *
 * @param data 数据
 * @returns {Promise}
 */
export function update(data:any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

/**
 * 删除数据
 *
 * @param idList ID数组
 * @returns {Promise}
 */
export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}
